import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { fetchMe } from './store/slices/authSlice';
import { fetchCart } from './store/slices/cartSlice';

import Navbar  from './components/layout/Navbar';
import Footer  from './components/layout/Footer';
import { PrivateRoute, AdminRoute } from './components/common/PrivateRoute';

// Customer pages
import Home          from './pages/customer/Home';
import Products      from './pages/customer/Products';
import ProductDetail from './pages/customer/ProductDetail';
import Cart          from './pages/customer/Cart';
import Checkout      from './pages/customer/Checkout';
import OrderSuccess  from './pages/customer/OrderSuccess';
import Dashboard     from './pages/customer/Dashboard';

// Auth pages
import Login    from './pages/auth/Login';
import Register from './pages/auth/Register';

// Admin
import AdminDashboard from './pages/admin/AdminDashboard';

// Info pages
import About         from './pages/info/About';
import Contact       from './pages/info/Contact';
import FAQs          from './pages/info/FAQs';
import TrackOrder    from './pages/info/TrackOrder';
import Returns       from './pages/info/Returns';
import SizeGuide     from './pages/info/SizeGuide';
import Adda          from './pages/info/Adda';
import PrivacyPolicy from './pages/info/PrivacyPolicy';
import TermsOfUse    from './pages/info/TermsOfUse';
import Disclaimer    from './pages/info/Disclaimer';

function Layout() {
  const dispatch  = useDispatch();
  const { token } = useSelector((s) => s.auth);
  const location  = useLocation();
  const isAdmin   = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (token) { dispatch(fetchMe()); dispatch(fetchCart()); }
  }, [token, dispatch]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--offwhite)' }}>
      {!isAdmin && <Navbar />}
      <main style={{ flex: 1 }}>
        <Routes>
          {/* Core */}
          <Route path="/"                element={<Home />} />
          <Route path="/products"        element={<Products />} />
          <Route path="/products/:slug"  element={<ProductDetail />} />
          <Route path="/login"           element={<Login />} />
          <Route path="/register"        element={<Register />} />

          {/* Protected customer */}
          <Route path="/cart"            element={<PrivateRoute><Cart /></PrivateRoute>} />
          <Route path="/checkout"        element={<PrivateRoute><Checkout /></PrivateRoute>} />
          <Route path="/order-success/:orderId" element={<PrivateRoute><OrderSuccess /></PrivateRoute>} />
          <Route path="/dashboard"       element={<PrivateRoute><Dashboard /></PrivateRoute>} />

          {/* Admin */}
          <Route path="/admin/*"         element={<AdminRoute><AdminDashboard /></AdminRoute>} />

          {/* Info / Static */}
          <Route path="/about"           element={<About />} />
          <Route path="/contact"         element={<Contact />} />
          <Route path="/faqs"            element={<FAQs />} />
          <Route path="/track-order"     element={<TrackOrder />} />
          <Route path="/returns"         element={<Returns />} />
          <Route path="/size-guide"      element={<SizeGuide />} />
          <Route path="/adda"            element={<Adda />} />
          <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
          <Route path="/terms-of-use"    element={<TermsOfUse />} />
          <Route path="/disclaimer"      element={<Disclaimer />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
